// import "./BasketballCourt.css";

import epdmflooringData from "../../data/epdm-flooringData";

import ServiceHero from "../../components/ServiceHero/ServiceHero";
import ServiceOverview from "../../components/ServiceOverview/ServiceOverview";
import ServiceBenefits from "../../components/ServiceBenefits/ServiceBenefits";
import ConstructionProcess from "../../components/ConstructionProcess/ConstructionProcess";
import TechnicalSpecs from "../../components/TechnicalSpecs/TechnicalSpecs";
import ServiceGallery from "../../components/ServiceGallery/ServiceGallery";
import WhyChooseService from "../../components/WhyChooseService/WhyChooseService";
import ServiceFAQ from "../../components/ServiceFAQ/ServiceFAQ";
import RelatedServices from "../../components/RelatedServices/RelatedServices";
import ServiceCTA from "../../components/ServiceCTA/ServiceCTA";

const EpdmFlooring = () => {
  return (
    <>
      <ServiceHero data={epdmflooringData} />

      <ServiceOverview data={epdmflooringData} />

      <ServiceBenefits data={epdmflooringData} />

      <ConstructionProcess />

      <TechnicalSpecs data={epdmflooringData} />

      <ServiceGallery data={epdmflooringData} />

      <WhyChooseService data={epdmflooringData} />

      <ServiceFAQ faqs={epdmflooringData.faqs} />

      <RelatedServices data={epdmflooringData} />

      <ServiceCTA data={epdmflooringData} />
    </>
  );
};

export default EpdmFlooring;
